import { doc, setDoc, deleteDoc, collection, query, where, getDocs } from 'firebase/firestore'
import { db, COLLECTIONS } from '@/lib/firebase'

function tokenDocId(uid: string, token: string): string {
  let hash = 0
  for (let i = 0; i < token.length; i++) {
    hash = (hash << 5) - hash + token.charCodeAt(i)
    hash |= 0
  }
  return `${uid}_${Math.abs(hash)}`
}

export async function saveAdminFcmToken(
  uid: string,
  email: string,
  token: string
): Promise<void> {
  const now = new Date().toISOString()
  const id = tokenDocId(uid, token)

  await setDoc(
    doc(db, COLLECTIONS.adminFcmTokens, id),
    {
      uid,
      email,
      token,
      adminAppOrigin:
        import.meta.env.VITE_ADMIN_APP_URL?.trim() ||
        (typeof window !== 'undefined' ? window.location.origin : ''),
      createdAt: now,
      updatedAt: now,
    },
    { merge: true }
  )
}

export async function removeAdminFcmTokensForUser(uid: string): Promise<void> {
  const q = query(
    collection(db, COLLECTIONS.adminFcmTokens),
    where('uid', '==', uid)
  )
  const snap = await getDocs(q)
  await Promise.all(
    snap.docs.map((d) => deleteDoc(doc(db, COLLECTIONS.adminFcmTokens, d.id)))
  )
}
